import classNames from "classnames";
import React from "react";

const TableHeaderRow = (props: { children: any; className?: string }) => {
  const { children, className } = props;
  
  return (
    <tr className={classNames("table-header-row", className)}>{children}</tr>
  );
};

export default TableHeaderRow;
